import React from 'react';
import PropTypes from 'prop-types';
import stylesG from '../../../../src/web/containers/App/App.scss';

const OMIContent = ({
  facilityId,
  companyId,
  reservationId,
  unitId,
  softwareProvider,
  baseUrl,
}) => (
    <div
      className={stylesG.reactContainerOMI}
      data-testid="omi-container"
      style={{
        margin: '0 10%',
        overflow: 'hidden',
      }}
    >
      <h3>Please complete your move-in</h3>
      <p style={{ marginBottom: '20px', borderBottom: '3px solid #e0e0e0', paddingBottom: '10px' }}>
        Once complete, you will receive instructions for how to access your unit.
      </p>

      <div id="react-container-omi">
        <div
          className="storable-webapps-onlinemovein"
          data-source="voyager"
          data-provider-id={softwareProvider}
          data-organization-id={companyId}
          data-facility-id={facilityId}
          data-reservation-id={`pal:reservation:${softwareProvider}:${facilityId};${reservationId}`}
          data-unit-id={unitId}
        />
      </div>
      <script
        type="text/javascript"
        id="undefined"
        src={`${baseUrl}dist/storable-webapps-onlinemovein.js`}
      />
      <link
        href={`${baseUrl}dist/storable-webapps-onlinemovein.css`}
        rel="stylesheet"
      />
    </div>
);

OMIContent.propTypes = {
  facilityId: PropTypes.string.isRequired,
  companyId: PropTypes.string.isRequired,
  reservationId: PropTypes.string.isRequired,
  unitId: PropTypes.string.isRequired,
  softwareProvider: PropTypes.string.isRequired,
  baseUrl: PropTypes.string.isRequired,
};

export default OMIContent;
